import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getAccounting() {
    yield takeEvery(actions.FETCH_ACCOUNTING_REQUESTED, function* (action) {
        try {
          const accounting = yield call(actions.getAccounting, action.payload);
          yield put({ type: actions.FETCH_ACCOUNTING_SUCCEEDED, accounting });
        } catch (error) {
          yield put({ type: actions.FETCH_ACCOUNTING_FAILED, error: error.message });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(getAccounting)
    ]);
}
